import pinyin from 'pinyin';

const colorList = ['#2CD2BC', '#3270FF', '#30D10A', '#1DADFF', '5D71FF', '#FFAE2F', '#A35EEB'];
const colorIndexList = [['a', 'b', 'c', 'd'], ['e', 'f', 'g', 'h'], ['i', 'j', 'k', 'l'], ['m', 'n', 'o', 'p'], ['q', 'r', 's', 't'], ['u', 'v', 'w', 'x'], ['y', 'z']];

/// 根据名字获取头像背景颜色
export const getNameColor = (name) => {
    const namePinyin = pinyin(name, { style: pinyin.STYLE_NORMAL }).join('');
    const firstChar = namePinyin.charAt(0);
    const index = colorIndexList.findIndex(arr => arr.includes(firstChar));
    return colorList[index];
};

/// 截取名字后两位
export const getLastName = (name) => {
    if (typeof name === 'string') {
        return name.slice(-2);
    }
    return '';
}